import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var ToastID = '###qrnWebToast###';
var SHORT = 2000;
var LONG = 3500;
var TOP = 20;
var BOTTOM = 80;
var MIDDLE = 50;

var Toast = /*#__PURE__*/function () {
  function Toast() {
    _classCallCheck(this, Toast);

    _defineProperty(this, "el", void 0);

    _defineProperty(this, "timer", null);

    _defineProperty(this, "SHORT", SHORT);

    _defineProperty(this, "LONG", LONG);

    _defineProperty(this, "TOP", TOP);

    _defineProperty(this, "BOTTOM", BOTTOM);

    _defineProperty(this, "MIDDLE", MIDDLE);

    this.el = document.createElement('div');
    this.el.id = ToastID;
    var defaultStyle = {
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      color: '#fff',
      padding: '5px 10px',
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
      textAlign: 'center',
      zIndex: '-9999',
      borderRadius: '5px',
      fontSize: '14px',
      display: 'none'
    };
    this.setStyle(defaultStyle);
    document.getElementsByTagName('body')[0].appendChild(this.el);
  } // 按照安卓的标准


  _createClass(Toast, [{
    key: "active",
    value: function active(offset) {
      var activeStyle = {
        top: "".concat(offset, "%"),
        zIndex: '999999',
        display: 'block'
      };
      this.setStyle(activeStyle);
    }
  }, {
    key: "notActive",
    value: function notActive() {
      var notActiveStyle = {
        zIndex: '-9999',
        display: 'none'
      };
      this.setStyle(notActiveStyle);
    }
  }, {
    key: "setStyle",
    value: function setStyle(style) {
      var _this = this;

      Object.keys(style).forEach(function (item) {
        _this.el.style[item] = style[item];
      });
    }
  }, {
    key: "show",
    value: function show(message) {
      var _this2 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

      // 如果不数据枚举的三种值则为默认MIDDLE
      if (offset !== TOP && offset !== BOTTOM && offset !== MIDDLE) {
        offset = MIDDLE;
      }

      this.el.innerHTML = message;
      this.active(offset);

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(function () {
        _this2.el.innerHTML = '';

        _this2.notActive();
      }, duration);
    }
  }]);

  return Toast;
}();

export default new Toast();